import React from 'react'
import {ProtocolosServicio} from "../components/lineamientos/ProtocolosServicio";

export const ProtocoloServicioPage = () => {
    return (
            <ProtocolosServicio/>
            )
            }
